export default __webpack_public_path__ + "static/media/guide_to_resistance.1f3a090d.png";